import { cn } from "@/lib/utils";

type IntegrationMetaBadgeVariant = "alias" | "category" | "reference";

interface IntegrationMetaBadgeProps {
  children: React.ReactNode;
  variant?: IntegrationMetaBadgeVariant;
  className?: string;
  title?: string;
}

const VARIANT_STYLES: Record<IntegrationMetaBadgeVariant, string> = {
  alias:
    "border-violet-200 bg-violet-50 text-violet-800 dark:border-violet-900/60 dark:bg-violet-950/40 dark:text-violet-200",
  category:
    "border-zinc-200 bg-zinc-100 text-zinc-700 dark:border-zinc-700 dark:bg-zinc-800/80 dark:text-zinc-200",
  reference:
    "border-border bg-muted/50 text-muted-foreground dark:bg-muted/30",
};

export function IntegrationMetaBadge({
  children,
  variant = "category",
  className,
  title,
}: IntegrationMetaBadgeProps) {
  return (
    <span
      title={title}
      className={cn(
        "inline-flex max-w-[180px] items-center rounded-full border px-2.5 py-1 text-xs font-medium truncate",
        VARIANT_STYLES[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
